import { render, staticRenderFns } from "./VerifyMessageLayout.vue?vue&type=template&id=e40f8482&scoped=true&"
import script from "./VerifyMessageLayout.vue?vue&type=script&lang=js&"
export * from "./VerifyMessageLayout.vue?vue&type=script&lang=js&"
import style0 from "./VerifyMessageLayout.vue?vue&type=style&index=0&id=e40f8482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40f8482",
  null
  
)

export default component.exports